/**
 * Convert a hex color (#rrggbb) to a soft light tint (CSS rgba),
 * suitable for backgrounds of dropdown options or chips.
 */
export function tintColor(hex, alpha = 0.18) {
  if (!hex || typeof hex !== 'string') return undefined;
  let h = hex.trim().replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (h.length !== 6) return undefined;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  if ([r, g, b].some((n) => Number.isNaN(n))) return undefined;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Build `<option style>` props for a colored item. */
export function colorOptionStyle(color) {
  const bg = tintColor(color, 0.18);
  return bg ? { backgroundColor: bg } : undefined;
}
